import React, {
  useEffect,
  useState
} from 'react';

import {
  fetchPreferences,
  savePreferences
} from '../../services/preferenceService';

function DreamHomePanel() {

  const [preferences, setPreferences] =
    useState({
      city: '',
      budget_min: '',
      budget_max: '',
      rooms: '',
      area_min: '',
      area_max: '',
      property_type: ''
    });

  const [loading, setLoading] =
    useState(true);

  const [saving, setSaving] =
    useState(false);

  useEffect(() => {

    loadPreferences();

  }, []);

  const loadPreferences = async () => {

    try {

      const data =
        await fetchPreferences();

      if (data) {
        setPreferences(data);
      }

    } catch (error) {

    } finally {

      setLoading(false);
    }
  };

  const handleChange = (e) => {

    setPreferences({
      ...preferences,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {

    e.preventDefault();

    try {

      setSaving(true);

      await savePreferences(
        preferences
      );

      alert('ذخیره شد');

    } catch (error) {

      alert('خطا');

    } finally {

      setSaving(false);
    }
  };

  if (loading) {

    return <div>Loading...</div>;
  }

  return (
    <div className="dream-home-panel">

      <h2>
        خانه رویایی
      </h2>

      <form onSubmit={handleSubmit}>

        <input
          name="city"
          placeholder="شهر"
          value={preferences.city}
          onChange={handleChange}
        />

        <input
          name="budget_min"
          placeholder="حداقل بودجه"
          value={preferences.budget_min}
          onChange={handleChange}
        />

        <input
          name="budget_max"
          placeholder="حداکثر بودجه"
          value={preferences.budget_max}
          onChange={handleChange}
        />

        <input
          name="rooms"
          placeholder="تعداد خواب"
          value={preferences.rooms}
          onChange={handleChange}
        />

        <button type="submit">

          {saving
            ? 'در حال ذخیره...'
            : 'ذخیره'}

        </button>

      </form>

    </div>
  );
}

export default DreamHomePanel;